import { Container, Row, Col } from '@everlywell/leaves';
import SectionWrapper from 'components/SectionWrapper';
import React from 'react';

import * as S from './styles';

interface Props {
  backgroundColor: string;
  slug: string;
  markdown: {
    childMarkdownRemark?: {
      html: string;
    };
  };
}

export const MarkDownSection: React.FC<Props> = ({
  markdown,
  slug,
  backgroundColor,
}: Props) => (
  <SectionWrapper
    data-testid={slug || 'markDownSection'}
    id={slug}
    backgroundColor={backgroundColor}
  >
    <Container>
      <Row>
        <Col xs>
          <S.Wrapper
            dangerouslySetInnerHTML={{
              // @ts-ignore
              __html: markdown.childMarkdownRemark?.html,
            }}
          />
        </Col>
      </Row>
    </Container>
  </SectionWrapper>
);

export default MarkDownSection;
